// extracted by mini-css-extract-plugin
export default {"messageBlock":"StatusRestrictionMessage_messageBlock__mnNmO"};